
import {
  REQUEST_CUSTOMER,
  REQUEST_CUSTOMER_ERROR,
  RECEIVE_CUSTOMER
} from 'actions'

export default (state = {}, { type, payload }) => {
  switch (type) {
    case REQUEST_CUSTOMER:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: true,
          didRequestFail: false
        }
      }
    case REQUEST_CUSTOMER_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: true
        }
      }
    case RECEIVE_CUSTOMER:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: false,
          data: payload.response
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/customer.js